import React from 'react';
import Resource from '../../../../common/v4/DataResource'
import Panel from '../../../../common/layout/Panel'
import { useParams } from 'react-router-dom';

const CarrierVoiceAccounts = (props) => {
    const { carrier_id } = useParams();
    const ingressData = {
        url: `/admin/carriers/carriers/${carrier_id}/voiceaccounts`,
        filter: {ATRDIRECTION: '2'},
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: false,
        userfilter: [],
        userFiltersimple: false,
        onclick: 'link',
        link: `/carriers/carriers/${carrier_id}/voiceaccounts/{id}`,
        metadata: [
            {
                'label': 'id',
                'source': 'ATRCARACCTID',
                'type': 'primary',
                'editable': false,
                'visible': false
            },
                {
                'label': 'ID Type',
                'source': 'ATRAUTHTYPEID',
                'type': 'select',
                'editable': true,
                'default': 'ip_address',
                visible: true
            },
            {
                'label': 'Name',
                'source': 'ATRALIAS',
                'type': 'text',
                'editable': true,
                'default': '',
                'placeholder': ''
            },
            {
                'label': 'IP Address',
                'source': 'ATRIPADDR',
                'type': 'text',
                'editable': true,
                'default': '',
                'placeholder': ''
            },
            {
                'label': 'Port',
                'source': 'port',
                'type': 'text',
                'editable': true,
                'default': '',
                'placeholder': ''
            },
            {
                'label': 'Prefix',
                'source': 'ATRPREFIX',
                'type': 'text',
                'editable': true,
                'default': '',
                'placeholder': ''
            },
                {
                'label': 'Enabled',
                'source': 'ATRSTATUS',
                'type': 'boolean',
                'editable': true,
                'default': true
            },
            {
                'label': 'Rate Profile',
                'source': 'ATRPRODUCTID',
                'type': 'select',
                'editable': true,
                'default': '',
            },
            { 
                'label': 'Delete',
                'type': 'delete',
            }
        ]
    }
    
    const egressData = {
        url: `/admin/carriers/carriers/${carrier_id}/voiceaccounts`,
        filter: {ATRDIRECTION: '1'},
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: `/carriers/carriers/${carrier_id}/voiceaccounts/{id}`,
        metadata: [
            {
                'label': 'id',
                'source': 'ATRCARACCTID',
                'type': 'primary',
                'editable': false,
                'visible': false
            },
                {
                'label': 'ID Type',
                'source': 'ATRAUTHTYPEID',
                'type': 'select',
                'editable': true,
                'default': 'ip_address',
                visible: true
            },
            {
                'label': 'Name',
                'source': 'ATRALIAS',
                'type': 'text',
                'editable': true,
                'default': '',
                'placeholder': ''
            },
            {
                'label': 'IP Address',
                'source': 'ATRIPADDR',
                'type': 'text',
                'editable': true,
                'default': '',
                'placeholder': ''
            },
            {
                'label': 'Port',
                'source': 'port',
                'type': 'text',
                'editable': true,
                'default': '',
                'placeholder': ''
            },
            {
                'label': 'Prefix',
                'source': 'ATRPREFIX',
                'type': 'text',
                'editable': true,
                'default': '',
                'placeholder': ''
            },
                {
                'label': 'Enabled',
                'source': 'ATRSTATUS',
                'type': 'boolean',
                'editable': true,
                'default': true
            },
            {
                'label': 'Rate Profile',
                'source': 'ATRPRODUCTID',
                'type': 'select',
                'editable': true,
                'default': '',
            }, { 
                'label': 'Delete',
                'type': 'delete',
            }
        ]
    }
    
    return (
        <div className="row">
            <div className="col-md-6">
                <Panel title = "Egress (Originating) Accounts">
                    <Resource 
                        addButtonText = "Create Egress Account" 
                        addButtonLink = {`/carriers/carriers/${carrier_id}/voiceaccounts/create_egress`}
                        data = {egressData} 
                        {...props} 
                    />
                </Panel>
            </div>
                <div className="col-md-6">
                <Panel title = "Ingress (Terminating) Accounts">
                    <Resource 
                        addButtonText = "Create Ingress Account" 
                        addButtonLink = {`/carriers/carriers/${carrier_id}/voiceaccounts/create_ingress`}
                        data = {ingressData} 
                        {...props} 
                    />
                </Panel>
            </div>
        </div>
    )        

}

export default CarrierVoiceAccounts;
